import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl03 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_03",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Train",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M24.89,46.75c-2.69,1.99-5.23,2.8-8.77,2.8s-6.08-.81-8.77-2.8l-1.19,1.61c3.02,2.24,6,3.2,9.96,3.2s6.93-.96,9.96-3.2l-1.19-1.61Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M27.47,34.04c-.35-4.85-4.99-10.04-11.33-10.04s-10.98,5.19-11.33,10.04c-.28,3.87-.24,9.61,1.52,14.98,1.62,4.92,3.33,6.97,9.81,6.97s8.19-2.06,9.81-6.97c1.77-5.37,1.8-11.11,1.52-14.98ZM24.05,48.4c-1.36,4.15-2.33,5.6-7.91,5.6s-6.55-1.45-7.91-5.6c-1.66-5.06-1.7-10.53-1.43-14.22.29-3.95,4.11-8.19,9.34-8.19s9.05,4.23,9.34,8.19c.27,3.69.23,9.15-1.43,14.22Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M22.9,34.02c-.32-3.36-4.41-4.25-6.77-4.25s-6.45.9-6.77,4.25c-.28,2.91.82,4.79,1.8,5.87,1.29,1.42,3.15,2.27,4.98,2.27s3.69-.85,4.98-2.27c.97-1.07,2.08-2.96,1.8-5.87ZM19.62,38.54c-.9.99-2.24,1.61-3.5,1.61s-2.59-.62-3.5-1.61c-.7-.77-1.49-2.15-1.29-4.33.23-2.42,4.74-2.44,4.78-2.44s4.55.03,4.78,2.44c.21,2.18-.58,3.56-1.29,4.33Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M11.34,46.81c-.44,0-.84-.29-.96-.73l-.66-2.34c-.15-.53.16-1.08.69-1.23.53-.15,1.08.16,1.23.69l.66,2.34c.15.53-.16,1.08-.69,1.23-.09.03-.18.04-.27.04Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M20.9,46.81c-.09,0-.18-.01-.27-.04-.53-.15-.84-.7-.69-1.23l.66-2.34c.15-.53.71-.84,1.23-.69.53.15.84.7.69,1.23l-.66,2.34c-.12.44-.53.73-.96.73Z"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Tachometer",
			children: [/* @__PURE__ */ _jsx("rect", {
				className: "red",
				x: 39.73,
				y: 40.96,
				width: 1.92,
				height: 9.62,
				rx: .96,
				ry: .96,
				transform: "translate(-5.08 86.46) rotate(-90)"
			}), /* @__PURE__ */ _jsx("path", {
				className: "black",
				d: "M45.5,32.27c-7.44,0-13.5,6.06-13.5,13.5,0,.55.45,1,1,1s1-.45,1-1c0-2.83,1.03-5.41,2.72-7.42l1.3,1.3c.38.38.98.38,1.36,0s.38-.98,0-1.36l-1.3-1.3c1.77-1.5,4.01-2.47,6.45-2.68v1.84c0,.53.43.96.96.96s.96-.43.96-.96v-1.84c2.45.2,4.68,1.17,6.45,2.68l-1.3,1.3c-.38.38-.38.98,0,1.36s.98.38,1.36,0l1.3-1.3c1.5,1.77,2.47,4.01,2.68,6.45h-1.84c-.53,0-.96.43-.96.96s.43.96.96.96h2.7c.06.01.12.04.19.04.55,0,1-.45,1-1,0-7.44-6.06-13.5-13.5-13.5Z"
			})]
		})]
	})]
});
export default SvgAppIcBefehl03;
